import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Row
} from "reactstrap"

//Import Images
import { colors } from 'constants/layout'
import { get } from "helpers/api_helper"
import digiLogo from "../../assets/images/digi-logo.png"

function CardUser(props) {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    try {
      setLoading(true)
      const res = await get(`api/org`);
      if (res && res.status == 200) {
        const user = JSON.parse(localStorage.getItem('authUser'))
        setProfile({ ...res.response.org, ...res.response, ...user })
      }
    } catch (err) {
      console.error("CardUser error:", err)
    } finally {
      setLoading(false)
    }
  }, [])

  const colorHex = {
    primary: '#556ee6',
    info: '#50a5f1',
    success: '#34c38f',
    warning: '#f1b44c',
    danger: '#f46a6a'
  }

  const getDaysLeftBadge = (days) => {
    const d = parseInt(days)
    if (isNaN(d)) return { bg: 'bg-soft-secondary text-secondary', text: 'Days left' }
    if (d > 90) return { bg: 'bg-success bg-soft text-success', text: `${d} Days Left` }
    if (d > 30) return { bg: 'bg-warning bg-soft text-warning', text: `${d} Days Left` }
    return { bg: 'bg-danger bg-soft text-danger', text: `${d} Days Left` }
  }

  const daysLeftBadge = profile?.subscription?.days
    ? getDaysLeftBadge(profile.subscription.days)
    : { bg: 'bg-soft-secondary text-secondary', text: 'Days left' }

  const statsList = [
    {
      title: "Clients",
      value: profile ? parseInt(profile.clients) : null,
      icon: "bx bx-group",
      color: "primary",
    },
    {
      title: "Employees",
      value: profile ? parseInt(profile.employees) : null,
      icon: "bx bx-id-card",
      color: "info",
    },
    {
      title: "Total New Orders",
      value: profile ? parseInt(profile.orders?.new) : null,
      icon: "bx bx-cart-add",
      color: "success",
    },
    {
      title: "Orders in Progress",
      value: profile ? parseInt(profile.orders?.progress) : null,
      icon: "bx bx-loader-circle",
      color: "warning",
    },
    {
      title: "Hold Orders",
      value: profile ? parseInt(profile.orders?.hold) : null,
      icon: "bx bx-pause-circle",
      color: "danger",
    },
  ]

  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col lg="12">
          <Card className="border-0 shadow-sm rounded-3 overflow-hidden fade-in-content" style={{
            background: 'linear-gradient(to right, #ffffff, #fafbfe)',
            borderRadius: '16px'
          }}>
            <CardBody className="p-4">
              <Row className="align-items-center">
                <Col xl="4" lg="12" md="12" className="border-xl-end-custom mb-4 mb-xl-0">
                  <div className="d-flex align-items-center pe-xl-3">
                    <div className="position-relative me-3 flex-shrink-0" style={{ width: '76px', height: '76px' }}>
                      {loading || !profile ? (
                        <div className="shimmer-box shimmer-avatar" style={{ width: '74px', height: '74px' }} />
                      ) : (
                        <img
                          src={profile?.image || digiLogo}
                          alt={profile?.title || "Logo"}
                          className="rounded-circle img-thumbnail shadow-sm"
                          style={{
                            width: '74px',
                            height: '74px',
                            objectFit: 'cover',
                            border: `3px solid ${colors[profile?.subscription?.package] || '#556ee6'}`,
                            padding: '2px',
                            backgroundColor: '#fff'
                          }}
                        />
                      )}
                    </div>
                    <div className="flex-grow-1 min-width-0">
                      {loading || !profile ? (
                        <>
                          <div className="shimmer-box shimmer-text" style={{ width: '70%', height: '18px', marginBottom: '8px' }} />
                          <div className="shimmer-box shimmer-text" style={{ width: '50%', height: '14px', marginBottom: '8px' }} />
                          <div className="shimmer-box shimmer-text" style={{ width: '30%', height: '18px', borderRadius: '10px' }} />
                        </>
                      ) : (
                        <>
                          <h5 className="text-dark fw-bold mb-1 text-truncate" style={{ fontSize: '16px' }}>
                            {profile?.title || (profile?.username)?.toUpperCase() || 'Dental Laboratory'}
                          </h5>
                          <p className="text-muted mb-2 font-size-13 text-truncate">
                            Welcome back, <span className="text-primary fw-medium">{profile?.username || profile?.email || 'Admin'}</span>
                          </p>

                          <div className="d-flex flex-wrap gap-2 align-items-center">
                            {profile?.role && (
                              <span className="badge bg-light text-muted border font-size-11 px-2 py-1">
                                Role: {profile?.role}
                              </span>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Col>

                <Col xl="8" lg="12" md="12">
                  <Row className="row-cols-2 row-cols-sm-3 row-cols-md-5 g-2 g-xl-3 justify-content-center">
                    {statsList.map((stat, idx) => (
                      stat.value > 0 && (
                        <Col key={idx}>
                          <div
                            className="p-2 p-md-3 rounded-3 text-center h-100 d-flex flex-column justify-content-center"
                            style={{
                              backgroundColor: '#fafafb',
                              border: '1px solid #f1f1f4',
                              borderRadius: '12px',
                              transition: 'all 0.25s ease-in-out',
                              cursor: 'default',
                              minWidth: 0
                            }}
                          >
                            <div className="avatar-xs avatar-sm-md mx-auto mb-2 d-flex align-items-center justify-content-center">
                              <span className={`avatar-title rounded-circle bg-${stat.color} bg-soft text-${stat.color} font-size-16`} style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <i className={stat.icon} />
                              </span>
                            </div>
                            {loading || stat.value === null || isNaN(stat.value) ? (
                              <div className="my-1">
                                <div className="shimmer-box shimmer-text mx-auto" style={{ width: '36px', height: '16px', marginBottom: 0 }} />
                              </div>
                            ) : (
                              <h4 className="fw-bold mb-1 text-dark font-size-16">{stat.value}</h4>
                            )}
                            <p className="text-muted text-truncate mb-0 font-size-11 fw-medium" title={stat.title}>
                              {stat.title}
                            </p>
                          </div>
                        </Col>
                      )
                    ))}
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default CardUser
